import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;
axios.defaults.withCredentials = true;

/** Given a portrait path like "/portraits/opp_iron_verse.png" (served by the
 * FastAPI static mount) or "/characters/iron_verse.png" (bundled in
 * frontend/public), return the correct absolute URL. */
export function apiPortraitUrl(path) {
 if (!path) return null;
 if (/^https?:\/\//.test(path)) return path;
 if (path.startsWith("/api/portraits/")) return `${BACKEND}${path}`;
 if (path.startsWith("/portraits/")) return `${BACKEND}/api${path}`; // legacy migration
 return path; // /characters/... served by frontend
}

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
 const [user, setUser] = useState(null);
 const [loading, setLoading] = useState(true);

 const refresh = async () => {
 try {
 const { data } = await axios.get(`${API}/auth/me`);
 setUser(data);
 } catch {
 setUser(null);
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => { refresh(); }, []);

 const login = async (email, password) => {
 const { data } = await axios.post(`${API}/auth/login`, { email, password });
 setUser(data.user);
 return data.user;
 };

 const register = async (payload) => {
 const { data } = await axios.post(`${API}/auth/register`, payload);
 setUser(data.user);
 return data.user;
 };

 const logout = async () => {
 try { await axios.post(`${API}/auth/logout`); } catch {}
 setUser(null);
 };

 return (
 <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, API }}>
 {children}
 </AuthCtx.Provider>
 );
}

export const useAuth = () => useContext(AuthCtx);
export { API };
